// Per-environment config for the static web bundle.
//
// Create React App inlines REACT_APP_* at BUILD time, but we ship one image across environments
// and source config from Cloud Run env vars (backed by Secret Manager). So at container startup
// docker-entrypoint.sh writes /env-config.js → `window._env_`, which index.html loads BEFORE the
// app bundle (CRA injects the bundle with `defer`, so this runs first).
//
// Lookup order: runtime (window._env_) → build-time (process.env, for local `npm start`) → fallback.
const runtime = (typeof window !== 'undefined' && window._env_) || {};

export function envVar(key, fallback = '') {
  const r = runtime[key];
  if (r != null && r !== '') return r;
  const b = process.env[key];
  if (b != null && b !== '') return b;
  return fallback;
}

// Backend base URL. Falls back to the prod backend so a misconfigured deploy still reaches the
// API instead of silently hitting same-origin (which returns the SPA's index.html → "no data").
export const API_BASE = envVar(
  'REACT_APP_API_URL',
  'https://sphyn-backend-423369016606.us-central1.run.app'
);
